import { TitleCasePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { ACTIVE_SCAN_STATUSES, ActiveScanStatus, SCAN_ACTION_TYPES } from '@ids-constants';
import { LoadingOverlayComponent } from '@microsec/components';
import { BaseComponent } from '@ids-components';
@Component({
  selector: 'app-device-active-scan-progress',
  templateUrl: './device-active-scan-progress.component.html',
  styleUrls: ['./device-active-scan-progress.component.scss'],
  imports: [LoadingOverlayComponent, TitleCasePipe],
})
export class DeviceActiveScanProgressComponent extends BaseComponent implements AfterViewInit {
  @Output() openFormEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() hidePanelEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeStatusEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() isLoading = false;

  @Input() scanStatus: ActiveScanStatus = ACTIVE_SCAN_STATUSES.NOT_RUNNING;

  ACTIVE_SCAN_STATUSES = ACTIVE_SCAN_STATUSES;

  SCAN_ACTION_TYPES = SCAN_ACTION_TYPES;

  async ngAfterViewInit() {
    await this.prepareConfigs();
  }
}
